import { signOut } from "@src/Modules/Authenticate/Store/services";

export const logout = async () => {
  const refreshToken = localStorage.getItem('refreshToken')
  await signOut(refreshToken);
  localStorage.clear();
  sessionStorage.clear();
  window.location.href = '/';
  return true;
};
